import { Grid, Typography } from '@mui/material';
import React from 'react';

const EmptyListMessage = () => {
    return (
        <Grid item>
            <Typography variant="h6">
                Nincs megjeleníthető adat!
            </Typography>
        </Grid>
    )
}

export default EmptyListMessage;